/**
 * DTE DscItem Formatter
 * Helper functions for formatting DscItem (description) field in DTE documents
 * following Facele constraints and best practices for PDF readability.
 *
 * IMPORTANTE: La fuente del PDF de Facele es PROPORCIONAL (no monoespaciada).
 * No existe un numero fijo de caracteres que garantice que Facele no re-envuelva una linea.
 * Mediciones empiricas:
 *   - Glifos angostos (I, 1, :): ~65 chars caben en una linea
 *   - Texto mixto (comas, numeros):  ~56 chars
 *   - Texto "ancho" (M, W, O):       ~29-47 chars
 *
 * Por esto, NO intentamos hacer word-wrap nosotros. Solo usamos \n para separar bloques
 * estructurales (ORIGEN/DESTINO, traslado, NO APTO) y dejamos que Facele envuelva
 * el texto continuo (mortalidad, datos) en su propia columna proporcional.
 */

const MAX_TOTAL_LENGTH = 1000;

/**
 * Formats DscItem text for DTE.
 * - Respeta \n existentes (bloques estructurales) sin agregar nuevos.
 * - Trunca a 1000 chars si el texto excede el limite de Facele.
 *
 * @param {string} text - The description text to format
 * @param {Object} options - Formatting options
 * @param {number} options.maxTotalLength - Max total chars (default: 1000)
 * @returns {string} Formatted text
 */
export const formatDscItem = (text, options = {}) => {
	const { maxTotalLength = MAX_TOTAL_LENGTH } = options;

	if (!text || typeof text !== 'string') return '';

	if (text.length > maxTotalLength) {
		return text.substring(0, maxTotalLength);
	}

	return text;
};
